import { Box, Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useTmOrderConfirmation } from "./common";
import { getResource } from "../../common/localization";

function getText(key: string, defaultMessage?: string) {
    return getResource("Ui.TmOrderConfirmation." + key, defaultMessage) as string;
}

export function OrderConfirmationDialog(props: { orderId: number; close: () => void; }) {
    const confirmation = useTmOrderConfirmation(props.orderId, true);
    const { isConfirmed, waiting, sending, isConfirmationSentRecently } = confirmation.useStore(p => ({
        isConfirmed: p.isConfirmed,
        waiting: p.waitAbort != null,
        sending: p.sendAbort != null,
        isConfirmationSentRecently: p.isConfirmationSentRecently,
    }));
    return <>
        <DialogTitle>{getText("Title")}</DialogTitle>
        <DialogContent>
            {!isConfirmed && (sending ? <Box my={2}>{getText("Sending")}</Box> : <Box>{getText("Sent")}</Box>)}
            {!isConfirmed && waiting && <Box my={2}>{getText("Waiting")}</Box>}
            {isConfirmed && <Box my={2}>{getText("Confirmed")}</Box>}
        </DialogContent>
        <DialogActions>
            <Button onClick={() => confirmation.useStore.getState().sendOrderConfirmation()} disabled={isConfirmationSentRecently || sending || isConfirmed}>{getText("Resend")}</Button>
            <Button onClick={() => props.close()}>{getResource("Ui.Close")}</Button>
        </DialogActions>
    </>;
}
